export function EffectivePolicyValue({
  value,
  base,
}: {
  value: number | null;
  base: number | null;
}) {
  const overridden = value !== base;
  return (
    <span className={overridden ? 'font-semibold text-blue-700' : ''}>
      {value != null ? Math.round(value).toLocaleString() : '—'}
      {overridden && base != null && (
        <span className="ml-1 text-gray-400 line-through">
          {Math.round(base).toLocaleString()}
        </span>
      )}
    </span>
  );
}
